var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['neo-tag', _vm.size, _vm.type, _vm.shape ? 'shape' : '', _vm.className],style:({ styles: _vm.styles })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }